/* Gouge Worldwide v2 THEME JS — ported from site_rebuild/mockups_v2/gw-v2.js. Only api(), the ATC payload,
   and the recently-viewed/recommendations data sources differ from the mockup (real Shopify endpoints).
   Framework-free. The Liquid port keeps this file byte-identical except for the body of api().
   Nothing here manifests content without a server-rendered equivalent; the two transient-UI
   exceptions are the cart lines (from /cart.js) and recently-viewed (localStorage handles). */
'use strict';
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(n) {                                  /* Number() so a string can never pass through */
    return '$' + (Number(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');
  }
  function json(sel) { var n = $(sel); try { return n ? JSON.parse(n.textContent) : null; } catch (e) { return null; } }
  /* Every value interpolated into innerHTML below comes from /cart.js or the catalog blob,
     i.e. from merchant-authored product data. Escape it: this file ports byte-identical
     into the live theme, where a title containing a quote or a tag would otherwise inject. */
  function esc(s){return String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))}

  /* ---------- cart state (same shape as /cart.js items) ---------------- */
  var lines = json('[data-gw-cart-lines]') || [];
  /* Upsell pool lives here, not next to the upsell block below: render() calls renderUpsell()
     and render() runs at init, ABOVE that block. `var` hoists the name but not the value, so a
     pool declared later is `undefined` at first render - it threw and killed the whole IIFE. */
  var upPool = (json('[data-gw-upsell-pool]') || []).slice();
  var upFetched = {};

  function local(route, payload) {
    if (route === '/cart/add') {
      var hit = lines.filter(function (l) { return l.key === payload.key; })[0];
      if (hit) {
        hit.quantity += payload.quantity;
        hit.final_line_price = hit.quantity * hit.price;   /* merging a re-add must reprice the line */
      } else { lines.push(payload); }
    } else if (route === '/cart/change') {
      lines = lines.map(function (l) {
        if (l.key !== payload.key) { return l; }
        l.quantity = payload.quantity;
        l.final_line_price = l.quantity * l.price;
        return l;
      }).filter(function (l) { return l.quantity > 0; });
    }
    return lines;
  }

  /* THE ONLY SWAP POINT FOR THE LIQUID PORT.
     Replace the body with:
       return fetch(route, {method:'POST', headers:{'Content-Type':'application/json'},
                            body: JSON.stringify(payload)}).then(function(r){return r.json();})
                    .then(function(cart){ lines = cart.items; return lines; });
     Every caller only assumes: a Promise resolving to the new line array. */
  function api(route, payload) {
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
    var p;
    if (route === '/cart/add') {
      opts.body = JSON.stringify({ items: [{ id: payload.id, quantity: payload.quantity }] });
      p = fetch('/cart/add.js', opts).then(function (r) { if (!r.ok) { throw r; } return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); });
    } else {
      opts.body = JSON.stringify({ id: payload.key, quantity: payload.quantity });
      p = fetch('/cart/change.js', opts);
    }
    return p.then(function (r) { if (!r.ok) { throw r; } return r.json(); }).then(function (cart) { lines = cart.items || []; return lines; });
  }

  /* ---------- overlay stack (ESC closes the topmost only) -------------- */
  var stack = [];
  function register(fn) { stack.push(fn); }
  function unregister(fn) { var i = stack.indexOf(fn); if (i > -1) { stack.splice(i, 1); } }
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Escape') { return; }
    if ($('dialog[open]')) { return; }   // a modal <dialog> is topmost and closes itself
    if (!stack.length) { return; }
    ev.preventDefault();
    stack.pop()();
  });

  /* ---------- cart drawer ---------------------------------------------- */
  var cart = $('[data-gw-cart]');
  function lineHtml(l) {
    return '<li class="gw-cart__line" data-gw-key="' + esc(l.key) + '">' +
      '<img src="' + esc(l.image + (String(l.image).indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" width="80" height="100" alt="" loading="lazy">' +
      '<div><a href="' + esc(l.url) + '" class="gw-cart__title">' + esc(l.product_title) + '</a>' +
      '<span class="gw-cart__variant">' + esc(l.variant_title) + '</span>' +
      '<div class="gw-qty"><button type="button" data-gw-qty="-1" aria-label="Decrease">−</button>' +
      '<output>' + esc(l.quantity) + '</output>' +
      '<button type="button" data-gw-qty="+1" aria-label="Increase">+</button></div></div>' +
      '<span class="gw-cart__price">' + money(l.final_line_price / 100) + '</span>' +
      '<button type="button" class="gw-cart__remove" data-gw-remove aria-label="Remove">×</button></li>';
  }
  function render() {
    if (!cart) { return; }
    var list = $('.gw-cart__lines', cart), empty = $('.gw-cart__empty', cart);
    var count = lines.reduce(function (a, l) { return a + l.quantity; }, 0);
    var total = lines.reduce(function (a, l) { return a + l.final_line_price; }, 0) / 100;
    if (list) { list.innerHTML = lines.map(lineHtml).join(''); list.hidden = lines.length === 0; }
    if (empty) { empty.hidden = lines.length > 0; }
    $$('[data-gw-cart-count]').forEach(function (n) { n.textContent = count; if (count === 0) { n.setAttribute('data-empty', ''); } else { n.removeAttribute('data-empty'); } });
    var t = $('[data-gw-cart-total]'); if (t) { t.textContent = money(total); }
    var blob = $('[data-gw-cart-lines]'); if (blob) { blob.textContent = JSON.stringify(lines); }
    renderUpsell();
  }
  function openCart() {
    if (!cart) { return; }
    cart.hidden = false; register(closeCart);
    var b = $('[data-gw-cart-close]', cart); if (b) { b.focus(); }
  }
  function closeCart() {
    if (!cart) { return; }
    cart.hidden = true; unregister(closeCart);
    var o = $('[data-gw-cart-open]'); if (o) { o.focus(); }
  }
  $$('[data-gw-cart-open]').forEach(function (b) { b.addEventListener('click', openCart); });
  if (cart) {
    $$('[data-gw-cart-close]', cart).forEach(function (b) { b.addEventListener('click', closeCart); });
    cart.addEventListener('click', function (ev) {
      var li = ev.target.closest ? ev.target.closest('.gw-cart__line') : null;
      if (!li) { return; }
      var key = li.getAttribute('data-gw-key');
      var hit = lines.filter(function (l) { return l.key === key; })[0];
      if (!hit) { return; }
      var step = ev.target.getAttribute('data-gw-qty');
      if (ev.target.hasAttribute('data-gw-remove')) {
        api('/cart/change', { key: key, quantity: 0 }).then(render);
      } else if (step) {
        api('/cart/change', { key: key, quantity: Math.max(0, hit.quantity + (step === '+1' ? 1 : -1)) }).then(render);
      }
    });
  }
  render();

  /* ---------- upsell rails (PDP buy box + cart drawer) ------------------ */
  /* Rows are server-rendered by snippets/gw-upsell-rail.liquid: each one is a real
     <form action="/cart/add"> whose submit button carries name="id", so it adds with JS off.
     Here we (a) intercept that so the add happens in place, and (b) keep the CART rail in step
     with the cart - it re-renders from [data-gw-upsell-pool] on every cart change, topped up
     from /recommendations/products.json for products the server paint never saw.
     upsellHtml() MUST mirror the snippet's markup - they render the same rail. */
  function upLabels(root) {
    root = root || document.body;
    return { add: root.getAttribute('data-gw-up-add-label') || 'ADD',
             added: root.getAttribute('data-gw-up-added-label') || 'ADDED',
             prompt: root.getAttribute('data-gw-up-prompt') || 'PICK SIZE' };
  }
  function upsellHtml(p, L) {
    var img = p.img ? '<img src="' + esc(p.img) + '" width="56" height="70" alt="' + esc(p.title) + '" loading="lazy">' : '';
    var price = money(p.price / 100) + (p.cap > p.price ? '<s class="gw-up__was">' + money(p.cap / 100) + '</s>' : '');
    var head = '<span class="gw-up__media">' + img + '</span><span class="gw-up__info">' +
      '<span class="gw-up__title">' + esc(p.title) + '</span><span class="gw-up__price">' + price + '</span></span>';
    var body;
    /* multi = the product HAS sizes, not "has more than one left": a piece down to its last size
       still shows that size as a chip, so nobody taps ADD and gets a size they never saw.
       Same rule as gw-upsell-rail.liquid - the two renderers must agree. */
    if (p.multi && p.variants.length) {
      body = '<details class="gw-up__row" data-gw-up-pick><summary class="gw-up__sum">' + head +
        '<span class="gw-up__add" data-gw-up-add>' + esc(L.add) + '</span></summary>' +
        '<div class="gw-up__sizes"><span class="gw-up__prompt">' + esc(L.prompt) + '</span>' +
        p.variants.map(function (v) {
          return '<button class="gw-up__size" type="submit" name="id" value="' + esc(v.id) + '" data-gw-up-size>' + esc(v.title) + '</button>';
        }).join('') + '</div></details>';
    } else {
      body = '<div class="gw-up__row"><div class="gw-up__sum">' + head +
        '<button class="gw-up__add" type="submit" name="id" value="' + esc(p.variants[0].id) + '" data-gw-up-add>' + esc(L.add) + '</button></div></div>';
    }
    return '<li class="gw-up__item" data-gw-up-item data-gw-product-id="' + esc(p.id) + '" data-gw-handle="' + esc(p.handle) + '">' +
      '<form class="gw-up__form" action="/cart/add" method="post" enctype="multipart/form-data" data-gw-up-form>' + body + '</form></li>';
  }
  function renderUpsell() {
    var root = $('[data-gw-up="cart"]'); if (!root || !upPool) { return; }
    var list = $('[data-gw-up-list]', root), L = upLabels(root);
    var limit = parseInt(root.getAttribute('data-gw-up-limit'), 10) || 2;
    var inCart = {}; lines.forEach(function (l) { inCart[l.product_id] = 1; });
    var seen = {}, show = [];
    upPool.forEach(function (p) {
      if (show.length >= limit || !p || seen[p.id] || inCart[p.id] || !p.variants || !p.variants.length) { return; }
      seen[p.id] = 1; show.push(p);
    });
    if (!lines.length || !show.length) {
      root.hidden = true; if (list) { list.innerHTML = ''; }
      /* Nothing to offer yet is usually "the pool has not met this cart". The main ATC form and a
         first paint with an empty cart both leave it empty, so top up and repaint once. upTopUp()
         marks the product fetched before it resolves, so this can never loop. */
      if (lines.length && !upFetched[lines[0].product_id]) { upTopUp().then(renderUpsell); }
      return;
    }
    if (list) { list.innerHTML = show.map(function (p) { return upsellHtml(p, L); }).join(''); }
    root.hidden = false;
  }
  function upNormalize(p) {          /* /recommendations/products.json + /products/{handle}.js -> pool shape */
    var vs = (p.variants || []).filter(function (v) { return v.available; });
    return { id: p.id, handle: p.handle, title: p.title, url: p.url, img: p.featured_image || '',
             price: p.price, cap: p.compare_at_price || 0, multi: (p.variants || []).length > 1,
             variants: vs.map(function (v) { return { id: v.id, title: v.title }; }) };
  }
  function upTopUp() {               /* one fetch per lead product, cached; the pool only grows */
    if (!lines.length) { return Promise.resolve(); }
    var pid = lines[0].product_id;
    if (upFetched[pid]) { return Promise.resolve(); }
    upFetched[pid] = 1;
    return fetchJson('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=6&intent=related')
      .then(function (d) {
        (d && d.products || []).forEach(function (p) {
          if (!p.available) { return; }
          for (var i = 0; i < upPool.length; i++) { if (upPool[i].id === p.id) { return; } }
          upPool.push(upNormalize(p));
        });
      });
  }
  /* submitter fallback: Safari < 15.4 has no SubmitEvent.submitter */
  var upLastBtn = null;
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest ? ev.target.closest('[data-gw-up-form] button[type="submit"]') : null;
    if (b) { upLastBtn = b; }
  }, true);
  document.addEventListener('submit', function (ev) {
    var f = ev.target.closest ? ev.target.closest('[data-gw-up-form]') : null;
    if (!f) { return; }
    ev.preventDefault();
    var btn = ev.submitter || ((upLastBtn && f.contains(upLastBtn)) ? upLastBtn : null) || $('button[type="submit"]', f);
    var vid = parseInt(btn && btn.value, 10);
    if (!vid || btn.disabled) { return; }
    var pick = $('[data-gw-up-pick]', f), face = $('[data-gw-up-add]', f);
    var L = upLabels(f.closest('[data-gw-up]'));
    btn.disabled = true;
    api('/cart/add', { id: vid, quantity: 1 })
      .then(function () {
        if (pick) { pick.open = false; }
        /* the cart rail repaints this row away; on the PDP it stays, so hand the button back */
        if (face) {
          face.textContent = L.added; face.setAttribute('data-gw-up-done', '');
          setTimeout(function () { face.textContent = L.add; face.removeAttribute('data-gw-up-done'); btn.disabled = false; }, 2200);
        } else { btn.disabled = false; }
        return upTopUp();
      })
      .then(function () { render(); if (cart && cart.hidden) { openCart(); } })
      .catch(function () {                /* native post: Shopify renders the real reason */
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'id'; h.value = vid;
        f.appendChild(h); f.submit();
      });
  });
  upTopUp().then(renderUpsell);

  /* ---------- header nav ----------------------------------------------- */
  var burger = $('[data-gw-nav-toggle]'), nav = $('.gw-header__nav');
  function closeNav() { if (!nav) { return; } nav.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); unregister(closeNav); }
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      if (open) { register(closeNav); } else { unregister(closeNav); }
    });
  }

  /* ---------- collection facets ---------------------------------------- */
  var fOpen = $('[data-gw-facets-open]'), facets = $('.gw-facets');
  if (fOpen && facets) {
    fOpen.setAttribute('aria-expanded', 'false');
    fOpen.addEventListener('click', function () {
      var open = !facets.hasAttribute('data-gw-open');
      if (open) { facets.setAttribute('data-gw-open', ''); } else { facets.removeAttribute('data-gw-open'); }
      fOpen.setAttribute('aria-expanded', String(open));
    });
  }

  /* sort select submits the facets form; the APPLY button is the no-JS path */
  var facetsForm = $('[data-gw-facets-form]');
  if (facetsForm) {
    var sortSel = $('[data-gw-sort]', facetsForm);
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        if (facetsForm.requestSubmit) { facetsForm.requestSubmit(); } else { facetsForm.submit(); }
      });
    }
  }

  /* ---------- product: variants, sticky bar, size guide, gallery ------- */
  /* Two shapes of buy box share this code (2026-09-21):
       legacy  - one radio per VARIANT (name="options[Size]", value = variant.title), radios carry data-gw-variant-id/-price.
       duo     - color radios ([data-gw-color-input]) + one radio per SIZE ([data-gw-size-input]); the size radios are
                 re-pointed at the chosen color's variants by applyColor(), so everything downstream stays identical. */
  var product = json('[data-gw-product]');
  var form = $('[data-gw-atc-form]');
  if (form && product) {
    var input = $('[data-gw-variant-input]', form);
    var sticky = $('[data-gw-sticky]');
    var stickySel = $('[data-gw-sticky-select]');
    var atcBtn = $('[data-gw-atc]', form);
    var colorInputs = $$('[data-gw-color-input]', form);
    var duo = colorInputs.length > 0;
    var opts = product.options || [];
    var optIdx = function (re) { for (var i = 0; i < opts.length; i++) { var nm = typeof opts[i] === 'string' ? opts[i] : opts[i].name; if (re.test(nm || '')) { return i; } } return -1; };
    var colorIdx = duo ? optIdx(/^colou?r$/i) : -1;
    var sizeIdx = colorIdx === 0 ? 1 : 0;
    var findVariant = function (color, size) {
      return (product.variants || []).filter(function (v) { return v.options && v.options[colorIdx] === color && v.options[sizeIdx] === size; })[0] || null;
    };
    var setAtc = function (avail) {
      [atcBtn, $('[data-gw-sticky-add]')].forEach(function (b) { if (b) { b.disabled = !avail; b.textContent = avail ? 'ADD TO CART' : 'SOLD OUT'; } });
    };
    var syncVariant = function (radio) {
      input.value = radio.getAttribute('data-gw-variant-id') || '';
      var p = money(parseFloat(radio.getAttribute('data-gw-price')));
      $$('[data-gw-price]').forEach(function (el) { el.textContent = p; });
      var ss = $('[data-gw-sticky-size]'); if (ss) { ss.textContent = radio.value; }
      if (duo) { setAtc(radio.getAttribute('data-gw-available') === 'true'); }
      try { history.replaceState({}, '', '?variant=' + input.value); } catch (e) { /* file:// */ }
    };
    var syncSelect = function () { if (stickySel) { stickySel.value = input.value; } };
    var applyColor = function (color) {
      var nm = $('[data-gw-color-name]'); if (nm) { nm.textContent = color.toUpperCase(); }
      var gal = $('[data-gw-gal]'); if (gal && gal.gwFilter) { gal.gwFilter(color); }
      var radios = $$('[data-gw-size-input]', form), checked = null, firstOk = null;
      radios.forEach(function (r) {
        var v = findVariant(color, r.value), ok = !!(v && v.available);
        if (v) { r.setAttribute('data-gw-variant-id', v.id); r.setAttribute('data-gw-price', v.price / 100); } else { r.removeAttribute('data-gw-variant-id'); }
        r.setAttribute('data-gw-available', ok ? 'true' : 'false');
        r.disabled = !ok; r.parentNode.classList.toggle('is-oos', !ok);
        if (r.checked) { checked = r; } if (ok && !firstOk) { firstOk = r; }
      });
      /* keep the shopper's size if this color has it; else first in-stock size; else leave it and show SOLD OUT */
      var pick = (checked && checked.getAttribute('data-gw-available') === 'true') ? checked : (firstOk || checked || radios[0]);
      if (pick) { pick.checked = true; syncVariant(pick); }
      if (stickySel) {
        stickySel.innerHTML = '';
        radios.forEach(function (r) {
          var vid = r.getAttribute('data-gw-variant-id'); if (!vid) { return; }
          var o = document.createElement('option'); o.value = vid; o.disabled = r.getAttribute('data-gw-available') !== 'true';
          o.textContent = r.value + (o.disabled ? ' — SOLD OUT' : ''); stickySel.appendChild(o);
        });
        syncSelect();
      }
      var v0 = pick ? findVariant(color, pick.value) : null, si = $('[data-gw-sticky-img]');
      if (si && v0 && v0.featured_image && v0.featured_image.src) {
        var src = v0.featured_image.src; si.removeAttribute('srcset'); si.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      }
    };
    form.addEventListener('change', function (ev) {
      if (ev.target.hasAttribute('data-gw-color-input')) { applyColor(ev.target.value); return; }
      if (ev.target.name === 'options[Size]') { syncVariant(ev.target); syncSelect(); }
    });
    if (stickySel) {
      stickySel.addEventListener('change', function () {
        var radio = $('input[name="options[Size]"][data-gw-variant-id="' + stickySel.value + '"]', form);
        if (radio && !radio.disabled) { radio.checked = true; syncVariant(radio); }
        else { input.value = stickySel.value; }
      });
    }
    /* named so the fallback can detach itself: `arguments.callee` throws under 'use strict', which used to swallow
       every failed add (e.g. Shopify's 422 for an unpublished product) with no feedback at all */
    var onSubmit = function (ev) {
      ev.preventDefault();
      var vid = parseInt(input.value, 10);
      if (!vid || (atcBtn && atcBtn.disabled)) { return; }
      var btn = $('button[type="submit"]', form); if (btn) { btn.disabled = true; }
      api('/cart/add', { id: vid, quantity: 1 })
        .then(function () { render(); openCart(); if (btn) { btn.disabled = false; } })
        .catch(function () { form.removeEventListener('submit', onSubmit); form.submit(); });   /* native /cart/add fallback: Shopify renders the reason */
    };
    form.addEventListener('submit', onSubmit);
    var stickyAdd = $('[data-gw-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) { form.requestSubmit(); }
        else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      });
    }
    var mainAtc = $('button[type="submit"]', form);
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      /* show whenever the real button is off-screen in EITHER direction (above the fold on mobile too);
         the fixed header counts as off-screen, hence the negative top margin */
      var hdrH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--gw-hdr-h'), 10) || 130;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var off = !en.isIntersecting;
          sticky.hidden = !off;
          if (off) { sticky.removeAttribute('inert'); } else { sticky.setAttribute('inert', ''); }
        });
      }, { threshold: 0, rootMargin: '-' + hdrH + 'px 0px 0px 0px' }).observe(mainAtc);
    }
  }

  var dlg = $('[data-gw-size-guide]');
  if (dlg) {
    var gOpen = $('[data-gw-size-guide-open]'), gClose = $('[data-gw-size-guide-close]', dlg);
    if (gOpen) { gOpen.addEventListener('click', function () { if (dlg.showModal) { dlg.showModal(); } else { dlg.setAttribute('open', ''); } }); }
    if (gClose) { gClose.addEventListener('click', function () { dlg.close(); }); }
  }

  /* gallery: one photo per slide. Slides/thumbs carrying data-gw-color are shown only for the selected color
     (class is-hidden otherwise); gwFilter(color) re-applies that and re-indexes so arrows, counter and thumbs
     only ever count what is visible. */
  (function () {
    var gal = $('[data-gw-gal]'), track = $('[data-gw-gallery]'); if (!gal || !track) { return; }
    var allImgs = $$('.gw-gallery__img', track), allThumbs = $$('.gw-gallery__thumb'), prev = $('[data-gw-gal-prev]', gal), next = $('[data-gw-gal-next]', gal), count = $('[data-gw-gal-count]', gal);
    var vis = function (l) { return l.filter(function (el) { return !el.classList.contains('is-hidden'); }); };
    var imgs = vis(allImgs), thumbs = vis(allThumbs), n = imgs.length;
    if (!n) { return; }
    function index() { return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))); }
    function go(i) { i = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function sync() {
      var i = index();
      if (prev) { prev.disabled = i === 0; } if (next) { next.disabled = i === n - 1; }
      if (count) { count.textContent = (i + 1) + ' / ' + n; }
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    allThumbs.forEach(function (b) { b.addEventListener('click', function () { go(thumbs.indexOf(b)); }); });
    if (prev) { prev.addEventListener('click', function () { go(index() - 1); }); }
    if (next) { next.addEventListener('click', function () { go(index() + 1); }); }
    gal.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); } if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); } });
    var raf = null; track.addEventListener('scroll', function () { if (raf) { return; } raf = requestAnimationFrame(function () { raf = null; sync(); }); }, { passive: true });
    window.addEventListener('resize', function () { go(index()); });
    /* an element's color: explicit data-gw-color (thumbs), else the color name its alt starts with (slides - image_tag
       drops data-* attrs). Same rule Liquid used for the first paint. No match = shown for every color. */
    var prod = json('[data-gw-product]'), colorNames = [], cIdx = -1;
    (prod && prod.options || []).forEach(function (o, i) { var nm = typeof o === 'string' ? o : o.name; if (/^colou?r$/i.test(nm || '')) { cIdx = i; } });   /* product|json lists options as plain names */
    if (cIdx > -1) { (prod.variants || []).forEach(function (v) { var c = v.options && v.options[cIdx]; if (c && colorNames.indexOf(c) < 0) { colorNames.push(c); } }); }
    var colorOf = function (el) {
      var c = el.getAttribute('data-gw-color'); if (c !== null) { return c; }
      var alt = (el.getAttribute('alt') || '').toLowerCase();
      return colorNames.filter(function (v) { return alt.indexOf(String(v).toLowerCase()) === 0; })[0] || '';
    };
    gal.gwFilter = function (color) {
      allImgs.concat(allThumbs).forEach(function (el) { var c = colorOf(el); el.classList.toggle('is-hidden', !!(c && color && c !== color)); });
      imgs = vis(allImgs); thumbs = vis(allThumbs); n = imgs.length;
      track.scrollTo({ left: 0 }); sync();
    };
    sync();
  })();

  /* ---------- recently viewed + recommendations (real endpoints) -------- */
  var recent = $('[data-gw-recent]');
  function readRecent() { try { return JSON.parse(localStorage.getItem('gw_recent') || '[]'); } catch (e) { return []; } }
  function writeRecent(v) { try { localStorage.setItem('gw_recent', JSON.stringify(v)); } catch (e) { /* blocked */ } }
  function toCard(pj) {                                   /* /products/{handle}.js or /recommendations/products.json shape */
    var vs = pj.variants || [], v = vs.filter(function (x) { return x.available; })[0] || vs[0] || {};
    var price = v.price != null ? v.price : pj.price, cap = v.compare_at_price;
    var md = cap && cap > price;
    return { title: pj.title, handle: pj.handle, price: price / 100, compare_at: md ? cap / 100 : null,
      pct_off: md ? Math.round((cap - price) / cap * 100) : null,
      img: pj.featured_image || (pj.images && pj.images[0]) || '', alt: pj.title, w: 600, h: 750, available: !!pj.available };
  }
  function cardHtml(p) {                                  /* ported from the mockup; gw-product-card.liquid is the server twin */
    var src = p.img ? esc(p.img + (String(p.img).indexOf('?') > -1 ? '&' : '?') + 'width=600') : '';
    return '<article class="gw-card' + (p.available ? '' : ' is-oos') + '" data-gw-handle="' + esc(p.handle) +
      '" data-gw-available="' + (p.available ? 'true' : 'false') + '">' +
      '<a class="gw-card__link" href="/products/' + esc(p.handle) + '"><div class="gw-card__media">' +
      (p.available ? '' : '<span class="gw-card__oos">SOLD OUT</span>') +
      (src ? '<img src="' + src + '" alt="' + esc(p.alt || p.title) + '" width="' + esc(p.w || 600) + '" height="' + esc(p.h || 750) + '" loading="lazy">' : '') +
      '</div><h3 class="gw-card__title">' + esc(p.title) + '</h3>' +
      '<p class="gw-card__price"><span>' + money(p.price) + '</span>' +
      (p.compare_at ? '<s class="gw-card__was">' + money(p.compare_at) + '</s>' : '') +
      (p.pct_off ? '<span class="gw-card__off">-' + esc(p.pct_off) + '%</span>' : '') +
      '</p></a></article>';
  }
  function fetchJson(u) { return fetch(u, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  if (product) {
    var seen = readRecent().filter(function (h) { return h !== product.handle; });
    writeRecent([product.handle].concat(seen).slice(0, 8));
  }
  if (recent) {
    var handles = readRecent().filter(function (h) { return !product || h !== product.handle; }).slice(0, 4);
    if (handles.length) {
      Promise.all(handles.map(function (h) { return fetchJson('/products/' + encodeURIComponent(h) + '.js'); })).then(function (list) {
        var show = list.filter(Boolean).map(toCard);
        if (show.length) { $('.gw-grid', recent).innerHTML = show.map(cardHtml).join(''); recent.hidden = false; }
      });
    }
  }
  var recs = $('[data-gw-recommendations]');
  if (recs && recs.getAttribute('data-gw-product-id')) {
    /* whatever the buy-box upsell rail is already offering must not come back as a card below it */
    var railed = {};
    $$('[data-gw-up="pdp"] [data-gw-up-item]').forEach(function (li) { railed[li.getAttribute('data-gw-handle')] = 1; });
    fetchJson('/recommendations/products.json?product_id=' + recs.getAttribute('data-gw-product-id') + '&limit=6&intent=related').then(function (d) {
      var items = (d && d.products || []).filter(function (p) { return p.available && !railed[p.handle]; }).slice(0, 4).map(toCard);
      var sec = recs.closest('section');
      if (items.length) { recs.innerHTML = items.map(cardHtml).join(''); if (sec) { sec.hidden = false; } }
    });
  }
})();

/* ---------- hero slideshow: slow auto-rotate, pause on hover/focus, dots ---------- */
(function () {
  var root = document.querySelector('[data-gw-slides]'); if (!root) { return; }
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gw-slide]'));
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gw-dot]'));
  if (slides.length < 2) { return; }
  var i = 0, timer = null, interval = (parseInt(root.getAttribute('data-gw-interval'), 10) || 7) * 1000;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
  }
  function start() { if (reduce) { return; } stop(); timer = setInterval(function () { show(i + 1); }, interval); }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }
  dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-gw-dot'), 10)); start(); }); });
  root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  /* swipe / drag: finger on mobile, mouse drag on desktop. Horizontal move > 40px flips a slide;
     anything smaller is treated as a normal tap so the buttons keep working. */
  var sx = null, sy = null, swiping = false;
  root.addEventListener('pointerdown', function (e) { if (e.button) { return; } sx = e.clientX; sy = e.clientY; swiping = false; stop(); }, { passive: true });
  root.addEventListener('pointermove', function (e) { if (sx === null) { return; } if (Math.abs(e.clientX - sx) > 12 && Math.abs(e.clientX - sx) > Math.abs(e.clientY - sy)) { swiping = true; } }, { passive: true });
  function endSwipe(e) {
    if (sx === null) { return; }
    var dx = e.clientX - sx; sx = sy = null;
    if (swiping && Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); root.setAttribute('data-gw-swiped', ''); setTimeout(function () { root.removeAttribute('data-gw-swiped'); }, 50); }
    start();
  }
  root.addEventListener('pointerup', endSwipe); root.addEventListener('pointercancel', function () { sx = sy = null; start(); });
  root.addEventListener('click', function (e) { if (root.hasAttribute('data-gw-swiped')) { e.preventDefault(); e.stopPropagation(); } }, true);
  root.addEventListener('dragstart', function (e) { e.preventDefault(); });
  start();
})();

/* ---------- floating header: height var, quick-row chevrons, drawer ---------- */
(function () {
  var hdr = document.querySelector('[data-gw-hdr]'); if (!hdr) { return; }
  var glass = hdr.firstElementChild;
  function setH() { document.documentElement.style.setProperty('--gw-hdr-h', (glass.offsetHeight + 16) + 'px'); }
  setH(); if (window.ResizeObserver) { new ResizeObserver(setH).observe(glass); } else { window.addEventListener('resize', setH); }
  /* quick row */
  var quick = hdr.querySelector('[data-gw-quick]'), list = hdr.querySelector('[data-gw-quick-list]');
  if (quick && list) {
    var prev = quick.querySelector('[data-gw-quick-prev]'), next = quick.querySelector('[data-gw-quick-next]');
    function update() {
      var over = list.scrollWidth > list.clientWidth + 2;
      quick.toggleAttribute('data-centered', !over);
      prev.hidden = !over || list.scrollLeft <= 2;
      next.hidden = !over || list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.7, behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.7, behavior: 'smooth' }); });
    list.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
  }
  /* drawer */
  var drawer = document.querySelector('[data-gw-drawer]'), openBtn = hdr.querySelector('[data-gw-drawer-open]');
  if (!drawer || !openBtn) { return; }
  var lastFocus = null;
  function close() { drawer.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); document.documentElement.classList.remove('gw-lock'); if (lastFocus) { lastFocus.focus(); } }
  function open() { lastFocus = document.activeElement; drawer.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('gw-lock'); var f = drawer.querySelector('[data-gw-drawer-close]'); if (f) { f.focus(); } }
  openBtn.addEventListener('click', function () { drawer.hidden ? open() : close(); });
  drawer.querySelectorAll('[data-gw-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) { close(); } });
})();

/* ---------- page-transition handoff: clicked card image morphs into the PDP lead image ---------- */
(function () {
  if (!('startViewTransition' in document)) { return; }
  document.documentElement.classList.add('gw-smooth');
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.gw-card__link, .gw-set__link, .gw-recent a'); if (!a || e.metaKey || e.ctrlKey || e.button) { return; }
    var img = a.querySelector('img'); if (!img) { return; }
    document.querySelectorAll('[style*="view-transition-name"], .gw-gallery__img--lead').forEach(function (el) { el.style.viewTransitionName = 'none'; });
    img.style.viewTransitionName = 'gw-lead';
  }, true);
  window.addEventListener('pageshow', function () { document.querySelectorAll('.gw-card__media img').forEach(function (el) { el.style.viewTransitionName = ''; }); document.querySelectorAll('.gw-gallery__img--lead').forEach(function (el) { el.style.viewTransitionName = ''; }); });
})();

/* ---------- loading bar: arm on internal link click, show only if the next page takes > 150ms ---------- */
(function () {
  var bar = document.querySelector('[data-gw-loadbar]'); if (!bar) { return; }
  var timer = null;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) { return; }
    if (a.target === '_blank' || a.hasAttribute('download') || a.origin !== location.origin) { return; }
    var href = a.getAttribute('href') || ''; if (href.charAt(0) === '#' || /^(mailto|tel|javascript):/.test(href)) { return; }
    if (a.pathname === location.pathname && a.search === location.search && a.hash) { return; }
    clearTimeout(timer); timer = setTimeout(function () { bar.setAttribute('data-state', 'loading'); }, 150);
  }, true);
  window.addEventListener('pagehide', function () { clearTimeout(timer); bar.setAttribute('data-state', 'done'); });
  window.addEventListener('pageshow', function () { clearTimeout(timer); bar.removeAttribute('data-state'); });
})();
